export default __webpack_public_path__ + "assets/ico_banner_testpilots-9b960ce3.svg";